import { LoginOutlined } from '@mui/icons-material'
import { Button, Stack, Typography } from '@mui/material'
import { ErrorCodeEnum } from '@ulysses-inc/harami_api_client'
import { useLocation } from 'react-router-dom'
import Goton from 'src/assets/images/goton.svg?react'
import Logo from 'src/assets/images/logo_report_blue_katakana.svg?react'
import { getBasePath, getKaminashiIDBasePath } from 'src/config'
import { useSendDummyErrorOnceInTenTimes } from 'src/features/sentry/useSendDummyErrorOnceInTenTimes'

export const Login = () => {
  // Sentry動作テスト用のイースターエッグ的ななにか😎
  const sendDummyErrorOnceInTenTimes = useSendDummyErrorOnceInTenTimes()

  // サービス未割り当てユーザーをサービスポータルに誘導する
  // ErrorCodeEnum は number だが URL クエリ経由では string なので Number 変換して比較する
  const location = useLocation()
  const errorCodeParam = new URLSearchParams(location.search).get('errorCode')
  const isServiceAssignmentRequired =
    errorCodeParam !== null &&
    Number(errorCodeParam) === ErrorCodeEnum.ServiceAssignmentRequiredError

  const handleClick = () => {
    if (isServiceAssignmentRequired) {
      window.location.href = `${getKaminashiIDBasePath()}/service_links`
      return
    }
    window.location.href = `${getBasePath()}/auth/login`
  }

  return (
    <Stack sx={{ height: '100dvh' }}>
      <Stack
        sx={{
          width: '100%',
          height: '100%',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Stack sx={{ width: '400px', alignItems: 'center', gap: 2 }}>
          <Logo width={287} height={40} />
          <Goton onClick={sendDummyErrorOnceInTenTimes} />
          <Typography variant="body1">
            {isServiceAssignmentRequired
              ? 'ご利用のサービスを選択するには、以下のボタンを押してください'
              : '以下のボタンからログインをお願いします'}
          </Typography>
          <Button
            variant="contained"
            startIcon={<LoginOutlined />}
            color="primary"
            onClick={handleClick}
          >
            {isServiceAssignmentRequired
              ? 'サービスポータルへ'
              : 'ログインに進む'}
          </Button>
        </Stack>
      </Stack>
    </Stack>
  )
}
